import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=b331f5c8&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=b331f5c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b331f5c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b331f5c8')) {
      api.createRecord('b331f5c8', component.options)
    } else {
      api.reload('b331f5c8', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=b331f5c8&scoped=true&", function () {
      api.rerender('b331f5c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4SWvEOW8Z3cw0/JS/teamMember.vue"
export default component.exports